export default __webpack_public_path__ + "static/media/second_candidato.f66713e5.png";